import { createContext, useContext, useReducer } from 'react';
import { IrpCreateEditState, IrpCreateEditReducer, ACTION_TYPES } from './irp-create-edit-reducer';
import { IIrpAddEditRequest } from '../../../../model/scp/irp/request/irp-add-edit-request';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

const IrpCreateEditContext = createContext<IrpCreateEditState | undefined>(undefined);
const IrpCreateEditDispatchContext = createContext({} as any);

const IrpCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { irpId } = useParams();

    const initialState: IrpCreateEditState = {
        file: undefined,
        tabIndex1: 0,
        irpRequest: { yearIrp: dayjs().year() } as IIrpAddEditRequest,
        modality: [],
        disputeMode: [],
        instrumentSummons: [],
        legalSupport: [],
        typeDocument: [],
        unidEntity: [],
        itemsIrpJson: "[]",
        irpId: irpId ? Number(irpId) : undefined,
        showValidationErrors: false,
    };

    const [state, dispatch] = useReducer(IrpCreateEditReducer, initialState);

    return (
        <IrpCreateEditContext.Provider value={state}>
            <IrpCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </IrpCreateEditDispatchContext.Provider>
        </IrpCreateEditContext.Provider>
    );
}

const useIrpCreateEditState = () => {
    const context = useContext(IrpCreateEditContext);
    if (context === undefined) {
        throw new Error('useIrpCreateEditState must be used within a IrpCreateEditProvider');
    }
    return context;
}

const useIrpCreateEditDispatch = () => {
    const context = useContext(IrpCreateEditDispatchContext);
    if (context === undefined) {
        throw new Error('useIrpCreateEditDispatch must be used within a IrpCreateEditProvider');
    }
    return context;
}

export { IrpCreateEditProvider, useIrpCreateEditDispatch, useIrpCreateEditState, ACTION_TYPES };
